import React, { useState } from 'react';
import axios from 'axios';

import './UploadSummary.css'

const UploadSummary = ({update_url, video_id, title, description, event_status}) => {
    
    const [isUpdating, setIsUpdating] = useState(false);
    const [fields, setFields] = useState({});
    const [activeEditors, setActiveEditors] = useState({});
    const [editorStatuses, setEditorStatuses] = useState({});
    //TODO: add duration, has ads, is free
    const [uploadStateClass, setUploadStateClass] = useState(`UploadState${event_status.charAt(0).toUpperCase()+event_status.slice(1)}`);
    const [eventStatus, setEventStatus] = useState(event_status);
    const uploadUrl = `${update_url}/${video_id}`;

    const activateEditor = (field_id, default_value) => {
        let eds = {...activeEditors};
        eds[field_id] = default_value;
        setActiveEditors(eds);
    }

    const deactivateEditor = (field_id) => {
        let eds = {...activeEditors};
        delete eds[field_id];
        setActiveEditors(eds);
    }

    const updateField = (field_id, new_value) => {
        let ae = {...activeEditors};
        ae[field_id] = new_value;
        setActiveEditors(ae);
        setEventStatus("UNPROCESSED");
        setUploadStateClass("UploadStateUnprocessed");
    }

    const resetField = (field_id, original_value) => {
        let ae = {...activeEditors};
        ae[field_id] = original_value;
        setActiveEditors(ae);
        let es = {...editorStatuses};
        delete es[field_id];
        setEditorStatuses(es);
        deactivateEditor(field_id);
        let f = {...fields};
        f[field_id] = original_value;
        setFields(f);
    }

    const saveField = async(field_id, prop_name) => {
        setEventStatus("PROCESSING");
        setUploadStateClass("UploadStateProcessing");

        let savedVal = activeEditors[field_id];
        let es = {...editorStatuses};
        delete es[field_id];
        setEditorStatuses(es);

        const formData = new FormData();
        formData.append('video_id', video_id);
        formData.append(prop_name, activeEditors[field_id]);

        try {
            setIsUpdating(true);

            const token = localStorage.getItem('token');
            if (token) {
                const response = await axios.patch(uploadUrl, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });

                console.log(`upload response: ${response}`);
            }
            deactivateEditor(field_id);
            es = {...editorStatuses};
            es[field_id] = 'Updated!';
            setEditorStatuses(es);
            setEventStatus("PROCESSED");
            setUploadStateClass("UploadStateProcessed");
            let f = {...fields};
            f[field_id] = savedVal;
            setFields(f);
        } 
        catch (error) {
            console.log(`Error while updating video data: ${error.response?.data?.detail || error.message}`);
            let es = {...editorStatuses};
            es[field_id] = `Error updating, send this to Sandgroper: ${error.response?.data?.detail || error.message}`;
            setEditorStatuses(es);
            setEventStatus("UNPROCESSED");
            setUploadStateClass("UploadStateUnprocessed");
        } 
        finally {
            setIsUpdating(false);
        }
    }

    const tid = `title_text_${video_id}`;
    const did = `description_text_${video_id}`;

    return (
        <form>
        <div className="EditorFields">
            <span className="FieldTitlePair">
                <span className="EditAreaCompact">
                    { tid in activeEditors ? (
                        <>
                        <input id={`title_input_${video_id}`} type="text" onInput={e => {updateField(tid, e.target.value)}} value={activeEditors[tid]}/>
                        { isUpdating ? <> ... </>
                            :
                            <>
                            <button className="EditButtonCompact" onClick={()=>{saveField(tid, 'name')}}>✔</button>
                            <button className="EditButtonCompact" onClick={()=>{resetField(tid, (tid in fields ? fields[tid] : title))}}>🗙</button>
                            </>
                        }
                        <p>{ tid in editorStatuses && editorStatuses[tid] }</p>
                        </>
                    ) : (
                        <>
                        <p id={tid}><b>{tid in fields ? fields[tid] : title}</b></p>
                        <button className="EditButtonCompact" onClick={() => {activateEditor(tid, title)} }>✎</button>
                        </>
                    )}
                </span>
                <div className="StatusArea">
                    <p className={uploadStateClass}>{eventStatus}</p>
                </div>
            </span>
            <span className="EditAreaCompact">
                { did in activeEditors ? (
                    <>
                    <textarea id={`description_input_${video_id}`} onInput={e => {updateField(did, e.target.value)}} value={activeEditors[did]}/>
                    {isUpdating ? <> ... </>
                        :
                        <>
                        <button className="EditButtonCompact" onClick={()=>{saveField(did, 'description')}}>✔</button>
                        <button className="EditButtonCompact" onClick={()=>{resetField(did, (did in fields ? fields[did] : description) )}}>🗙</button>
                        </>
                    }
                    <p>{ did in editorStatuses && editorStatuses[did] }</p>
                    </>
                ) : (
                    <>
                        <p id={did}>{did in fields ? fields[did] : (description.length > 0) ? description : 'No description'}</p>
                        <button className="EditButtonCompact" onClick={() => {activateEditor(did, description)} }>✎</button>
                    </>
                ) }
                
            </span>
        </div>

        </form>
    );
};

export default UploadSummary;